/**
 * Formatte une date pour l'affichage en français.
 * Gère les formats ISO, timestamps, et les valeurs nulles.
 * @param {string|Date|null} dateValue - La valeur de date à formater
 * @param {object} options - Options de formatage
 * @param {boolean} options.withTime - Inclure l'heure (défaut: false)
 * @returns {string} La date formatée ou '-'
 */
export const formatDate = (dateValue, { withTime = false } = {}) => {
  if (!dateValue) return '-';

  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '-';

    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    };

    if (withTime) {
      options.hour = '2-digit';
      options.minute = '2-digit';
    }

    return date.toLocaleDateString('fr-FR', options);
  } catch {
    return '-';
  }
};

/**
 * Récupère la date de création depuis un objet (gère created_at et createdAt).
 */
export const getCreatedAt = (obj) => {
  if (!obj) return null;
  return obj.createdAt || obj.created_at || null;
};

/**
 * Formatte la date de création d'un objet.
 */
export const formatCreatedAt = (obj, options) => {
  return formatDate(getCreatedAt(obj), options);
};
